module.exports = __webpack_public_path__ + "img/Vector.3ac9196c.svg";